// @flow

import React from "react";
import { Route, Redirect } from "react-router-dom";

import store from "./store";
import TemplateChooser from "../js/containers/TemplateChooser";
import SearchPage from "../js/containers/SearchPage";
import LoginRegister from "../js/containers/LoginRegister";
import ForgotPassword from "./containers/ForgotPassword";
import ResetPassword from "./containers/ResetPassword";
import EditProfile from "../js/containers/EditProfile";
import Config from "../js/constants/Config";
import Logout from "../js/containers/Logout";
import ProfileClubs from "./containers/ProfileClubs";
import OktaRedirect from "./containers/OktaRedirect";
import Cart from "./containers/Cart";
import Checkout from "./containers/Checkout";
import CheckoutSuccess from "./containers/CheckoutSuccess";
import ProfileTickets from "./containers/ProfileTickets";
import ProfilePurchases from "./containers/ProfilePurchases";
import ManageClubs from "./containers/ManageClubs";
import ManageEvent from "./containers/ManageEvent";
import EditEvent from "./containers/EditEvent";
import EAPLanding from "./containers/EAPLanding";
import EAPBenefits from "./containers/EAPBenefits";
import EventTerms from "./containers/EventTerms";
import ManagedEvents from "./containers/ManagedEvents";

const routes = [
    // search
    {
        path: `${Config.routes.search}`,
        component: SearchPage,
    },
    // account base redirect
    {
        path: `${Config.routes.accountBaseRoute}`,
        render: () => <Redirect to={Config.routes.login} />,
        exact: true,
    },
    // login
    {
        path: `${Config.routes.login}`,
        render: () => <PublicRoute component={LoginRegister} />,
        component: LoginRegister,
        exact: true,
    },
    // register
    {
        path: `${Config.routes.register}`,
        render: () => <PublicRoute component={LoginRegister} />,
        component: LoginRegister,
        exact: true,
    },
    // okta redirect route
    {
        path: `${Config.routes.oktaCallback}`,
        component: OktaRedirect,
    },
    // forgot password
    {
        path: `${Config.routes.forgotPassword}`,
        render: () => <PublicRoute component={ForgotPassword} />,
        component: ForgotPassword,
        exact: true,
    },
    // reset password
    {
        path: `${Config.routes.resetPassword}`,
        render: () => <PublicRoute component={ResetPassword} />,
        component: ResetPassword,
    },
    // managed events listing
    {
        path: `${Config.routes.managedEvents}`,
        render: () => <PrivateRoute component={ManagedEvents} />,
        component: ManagedEvents,
        exact: true,
    },
    // expired membership
    {
        path: `${Config.routes.expiredMembership}`,
        render: () => <PrivateRoute component={ProfileClubs} />,
        component: ProfileClubs,
        exact: true,
    },
    // current membership
    {
        path: `${Config.routes.currentMembership}`,
        render: () => <PrivateRoute component={ProfileClubs} />,
        component: ProfileClubs,
        exact: true,
    },
    // past events
    {
        path: `${Config.routes.pastTickets}/:id?`,
        render: () => <PrivateRoute component={ProfileTickets} />,
        component: ProfileTickets,
        exact: true,
    },
    // incoming events
    {
        path: `${Config.routes.incomingTickets}/:id?`,
        render: () => <PrivateRoute component={ProfileTickets} />,
        component: ProfileTickets,
        exact: true,
    },
    // purchases
    {
        path: `${Config.routes.purchases}/:id?`,
        render: () => <PrivateRoute component={ProfilePurchases} />,
        component: ProfilePurchases,
    },
    // edit profile
    {
        path: `${Config.routes.editProfile}`,
        render: () => <PrivateRoute component={EditProfile} />,
        component: EditProfile,
        exact: true,
    },
    // manage clubs
    {
        path: `${Config.routes.manageClubs}/:id?/:mode?/:event_id?`,
        render: () => <PrivateRoute component={ManageClubs} />,
        component: ManageClubs,
    },
    // manage event
    {
        path: `${Config.routes.manageEvent}/:id?`,
        render: () => <PrivateRoute component={ManageEvent} />,
        component: ManageEvent,
        exact: true,
    },
    // managed event
    {
        path: `${Config.routes.managedEvent}/:id?`,
        render: () => <PrivateRoute component={ManageEvent} />,
        component: ManageEvent,
        exact: true,
    },
    // edit event
    {
        path: `${Config.routes.manageEvent}/:id?/edit`,
        render: () => <PrivateRoute component={EditEvent} />,
        component: EditEvent,
        exact: true,
    },
    // eap landing
    {
        path: Config.routes.eapLanding,
        render: () => <PrivateRoute component={EAPLanding} />,
        component: EAPLanding,
        exact: true,
    },
    // eap benefits
    {
        path: Config.routes.eapBenefits,
        render: () => <PrivateRoute component={EAPBenefits} />,
        component: EAPBenefits,
        exact: true,
    },
    // logout
    {
        path: `${Config.routes.logout}`,
        // render: () => <PrivateRoute component={Logout} />,
        component: Logout,
        exact: true,
    },
    // cart
    {
        path: `${Config.routes.cart}`,
        component: Cart,
    },
    // checkout
    {
        path: `${Config.routes.checkout}`,
        component: Checkout,
        exact: true,
    },
    // checkout success
    {
        path: `${Config.routes.checkoutSuccess}/:orderId`,
        component: CheckoutSuccess,
        exact: true,
    },
    // event terms and conditions agreement
    {
        path: `${Config.routes.eventTerms}`,
        component: EventTerms,
    },
    // cms page
    {
        path: "*",
        component: TemplateChooser,
    },
];

// Private route for user session required views (Account, etc)
export const PrivateRoute = ({ component: Component, ...rest }: any): any => {
    const [loggedIn] = React.useState(store.getState().user.loggedIn);
    const [user] = React.useState(store.getState().user);
    console.log("IsLoggedIn", loggedIn);
    console.log("user", user);

    return (
        <Route
            {...rest}
            render={(props: any): any => {
                if (!loggedIn) {
                    return (
                        <Redirect
                            to={{
                                pathname: Config.routes.login,
                                state: { from: document.location.pathname },
                            }}
                        />
                    );
                }
                return <Component {...props} />;
            }}
        />
    );
};

// Public route redirects for logged in users
export const PublicRoute = ({ component: Component, ...rest }: any): any => {
    const [loggedIn] = React.useState(store.getState().user.loggedIn);

    return (
        <Route
            {...rest}
            render={(props: any): any =>
                !loggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: Config.routes.editProfile,
                            state: { from: document.location.pathname },
                        }}
                    />
                )
            }
        />
    );
};

export default routes;
